// extracted by mini-css-extract-plugin
export default {"mania":"heading_mania__7hWTb"};